import type { PortalEvent } from "./protocol.js";
import type { Transport } from "./transport.js";

export class UserSoundClient {
  private listeners: Set<(event: PortalEvent) => void> = new Set();

  constructor(private transport: Transport) {
    transport.onMessage((data) => this.handleMessage(data));
  }

  onEvent(cb: (event: PortalEvent) => void): () => void {
    this.listeners.add(cb);
    return () => this.listeners.delete(cb);
  }

  handleMessage(raw: string | unknown): void {
    try {
      const payload =
        typeof raw === "string" ? (JSON.parse(raw) as PortalEvent) : (raw as PortalEvent);
      if (payload && typeof payload.eventType === "string") {
        for (const cb of this.listeners) {
          cb(payload);
        }
      } else {
        this.dispatch({ eventType: "message", data: raw });
      }
    } catch {
      this.dispatch({ eventType: "message", data: raw });
    }
  }

  private dispatch(event: PortalEvent): void {
    for (const cb of this.listeners) {
      cb(event);
    }
  }
}
